import * as csv from "jquery-csv"
import { isValidDate, parseDate } from "./calendarutil"

async function fetchCSV(url) {
  try {
    let response = await fetch(url)
    let text = await response.text()
    return text
  } catch (error) {
    console.log("could not fetch csv from url", error)
  }
}

function parse(csvstring) {
  let csvparsedarrays = csv.toArrays(csvstring)
  // console.log(csvparsedarrays)

  let ingamemonth = _findIngameMonth(csvparsedarrays)
  // console.log("--Ingamemonth:", ingamemonth)
  let events = _findEvents(csvparsedarrays)
  // console.log({events, ingamemonth})
  return {events, ingamemonth}
}

function _findEvents(csvparsedarrays) {
  const _arr = csvparsedarrays;
  const symbol = "#DATE"

  let cell = _findCellWithStartsymbol(_arr, symbol)

  // if Symbol was not found, return empty event array
  if(cell.row < 0 || cell.col < 0)
    return [];

  //event dates start one row below the found symbol
  //remove all rows above to the symbol
  let datearrays = _arr.filter((row, rowindex) => rowindex >= cell.row)
  //remove all columns left to the symbol
  datearrays = datearrays.map(row => row.filter((col, colindex)=> colindex>=cell.col))

  //parse events if date is valid
  const eventarray = []
  for(let r=0; r<datearrays.length; r++){
    let row = datearrays[r]
    let parsedDate = parseDate(row[0])
    if(isValidDate(parsedDate)){
      // console.log(row)
      // console.log(parsedDate)
      eventarray.push({date:parsedDate, eventtext:row[1], eventurl:row[2]})
    }
  }
  return eventarray;
}



function _findIngameMonth(csvparsedarrays) {
  const _arr = csvparsedarrays;
  const symbol = "#INGAME_MONTH"

  let cell = _findCellWithStartsymbol(csvparsedarrays, symbol)
  // if date not found, return placeholder
  if(cell.row < 0 || cell.col < 0)
    return [1000, 1];

  // console.log("#INGAME_MONTH", csvparsedarrays)
  // console.log(_arr[cell.row][cell.col])
  //the value we are interested in should be one cell below the found symbol

  let value = _arr[cell.row + 1][cell.col]; //e.g.:  "08-1003"
  value = "01-" + value               //add a filler-day at front, so we can reuse our date-utilitys

  let parsedValue = parseDate(value)
  if (isValidDate(parsedValue)) {
    return [parsedValue[0], parsedValue[1]];
  }

  // data in sheet was not valid "mm-yyyy" format
  // return placeholder fallback month "01-1000"
  return [1000, 1];
}

function _findCellWithStartsymbol(csvparsedarrays, startsymbol) {
  const _arr = csvparsedarrays;
  let resrow = -1, rescol = -1;

  //find first cell that starts with 'symbol'
  for (let row = 0; row < _arr.length; row++) {
    for (let col = 0; col < _arr[row].length; col++) {
      if (_arr[row][col].startsWith(startsymbol)) {
        resrow = row;
        rescol = col;
        break;
      }
    }
  }
  return { row: resrow, col: rescol }
}


export { fetchCSV, parse }